import { connect } from "react-redux";

import actions from "../../actions";
import TooltipChiba from "../../components/matrix/TooltipChiba";

const mapStateToProps = (state) => {
  return {
    masters: state.construction.masters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TooltipChiba);
